import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import classNames from 'classnames';
import css from './TableCellSubdomainInput.css';
import TextField from '../../../../components/molecules/TextField';
import Icon, { IconTypes } from '../../../../components/foundations/Icon';
import Tooltip from '../../../../components/molecules/Tooltip';

const translationPrefix = 'STATIC.PAGES.MANAGE_LINKS.SUB_DOMAIN.TABLE';

const TableCellSubdomainInput = props => {
    const { value, type, className, tdClassName, rowIndex, onChange, row, error } = props;
    const { zone, isFavourite, isCreatingDomain, isRowDisabled, isLoading } = row;

    return (
        <td className={classNames(tdClassName, isCreatingDomain ? css.backgroundCreate : '')}>
            {!isCreatingDomain || rowIndex > 0 ? (
                <div className={css.labelContainer}>
                    {`${value}.${zone}`}
                    {isFavourite && (
                        <div className={css.defaultLabel}>
                            <Translate id={`${translationPrefix}.DEFAULT`} />
                        </div>
                    )}
                </div>
            ) : (
                <div className={css.domainInputContainer}>
                    <div className={css.domainInputWrapper}>
                        <TextField
                            type={type || 'text'}
                            value={value || ''}
                            error={error}
                            containerClass={classNames(error ? css.errorMargin : css.noMargin, css.input, className)}
                            onChange={onChange}
                            errorClassName={css.errorClassName}
                            placeholder={`${translationPrefix}.PLACEHOLDER_CREATE`}
                            disabled={isLoading || isRowDisabled}
                        />
                        <div className={css.domainSuffix}>.{zone}</div>
                        <Tooltip
                            titleTranslationKey="STATIC.PAGES.MANAGE_LINKS.SUBDOMAIN_SHELF_INFO"
                            wrapperClass={css.iconContainer}
                        >
                            <Icon className={css.icon} name="help-circle" />
                        </Tooltip>
                    </div>
                </div>
            )}
        </td>
    );
};

TableCellSubdomainInput.propTypes = {
    value: PropTypes.string,
    type: PropTypes.string,
    row: PropTypes.object,
    className: PropTypes.string,
    onChange: PropTypes.func,
    tdClassName: PropTypes.string,
    rowIndex: PropTypes.number,
    error: PropTypes.string,
};

export default TableCellSubdomainInput;
